<template>
  <div class="modal-wrapper" ref="modal" tabindex="0">
    <div @click="$emit('close')" class="modal-overlay"></div>
    <div
      class="modal"
      @click.stop
      :style="{ height, width, maxHeight, maxWidth }"
    >
      <div class="header">
        <slot name="header">
          <ModalHeader
            :title="title"
            :closeBtn="closeBtn"
            :actionBeforeLogout="actionBeforeLogout"
            :logOutBtn="logOutBtn"
            :readArticleUrl="readArticleUrl"
            @close="$emit('close')"
          />
        </slot>
      </div>

      <div
        class="body"
        :class="[bodyClass]"
        :style="{ padding: bodyPadding, overflow: bodyOverflow }"
      >
        <slot></slot>
      </div>

      <div :style="{ padding: footerPadding }">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import ModalHeader from './header.vue';

withDefaults(
  defineProps<{
    title?: string;
    closeBtn?: boolean;
    logOutBtn?: boolean;
    readArticleUrl?: string;
    bodyOverflow?: string;
    bodyClass?: string;
    height?: string;
    width?: string;
    maxHeight?: string;
    maxWidth?: string;
    bodyPadding?: string;
    footerPadding?: string;
    actionBeforeLogout?: () => void;
  }>(),
  {
    title: '',
    closeBtn: true,
    logOutBtn: false,
    readArticleUrl: '',
    bodyOverflow: 'hidden',
    bodyPadding: '24px',
    footerPadding: '10px 24px',
    actionBeforeLogout: () => {},
  },
);

const modal = ref<HTMLElement | null>(null);

onMounted(() => {
  modal.value?.focus();
});
</script>
<style scoped lang="scss">
.modal-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 200;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  height: 100vh;
  background: var(--color-modalbg) !important;
}

.modal-overlay {
  background-color: #212121;
  opacity: 0.15;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  position: absolute;
  height: 100vh;
}

.modal {
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: var(--color-white);
  width: fit-content;
  max-height: 98%;
  max-width: 98%;
  border-radius: 5px;
  overflow: hidden;
  box-shadow:
    0 11px 15px -7px rgba(0, 0, 0, 0.2),
    0 24px 38px 3px rgba(0, 0, 0, 0.14),
    0 9px 46px 8px rgba(0, 0, 0, 0.12);
}

.body {
  height: 100%;
  overflow: hidden;
  border-bottom: 1px solid var(--color-gray10) !important;
}

.header {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
</style>
